import { bold, num, tableRows } from "../../utils/xlsx";
import { download, ExportButton, sheetHeading } from "../accounting/common";

// Excel export for the list-shaped reports: the same column configs that drive the on-screen table drive the sheet.

export { download, ExportButton, sheetHeading };

/** How the chosen (optional) date range is described under the sheet title. */
export const rangeLabel = (fromDate, toDate) => {
  if (fromDate && toDate) return `${fromDate} to ${toDate}`;
  if (fromDate) return `From ${fromDate}`;
  if (toDate) return `Up to ${toDate}`;
  return "All dates";
};

/** One sheet: title, a line describing the filters, then the table with a totals row. */
export const tableSheet = (title, filters, columns, rows, sheetName) => ({
  name: sheetName || title,
  rows: [...sheetHeading(title, filters), ...tableRows(columns, rows, { totals: true })],
});

const LEDGER_COLUMNS = [
  { key: "date", label: "Date" },
  { key: "particulars", label: "Particulars" },
  { key: "vchType", label: "Vch Type" },
  { key: "vchNo", label: "Vch No" },
  { key: "debit", label: "Debit", format: "money" },
  { key: "credit", label: "Credit", format: "money" },
];

/** A running-account sheet: opening balance, the vouchers with Dr / Cr totals, then the closing balance. */
export const ledgerSheet = (title, filters, statement, closingLabel = "Closing Balance") => ({
  name: title,
  rows: [
    ...sheetHeading(title, filters),
    [bold("Opening Balance"), "", "", "", bold(num(statement.openingBalance))],
    ...tableRows(LEDGER_COLUMNS, statement.entries || [], { totals: true }),
    [bold(closingLabel), "", "", "", bold(num(statement.closingBalance))],
  ],
  widths: [14, 44, 16, 24, 16, 16],
});

export const fileName = (title, suffix) => `${title}${suffix ? ` ${suffix}` : ""}`.replace(/[\\/:*?"<>|]/g, "-");
